export default {
  'home.title': 'Home',
  'home.event': 'Event',
  'home.news': 'Announcement',
  'home.event_information': 'Event Information',
  'home.announcement': 'Announcement Information',
  'home.goto': 'Go to',
  'home.latest_events': 'Latest Events',
  'home.more_events': 'More Events',
  'home.empty': 'No content available at the moment',
} as Record<string, string>;
